import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: .5em;

  svg {
    width: 20px;
    height: 20px;
    fill: #D65900;
  }

  p {
    font-size: .75em;
    color: #940420;
    margin-left: .3em;
    margin-top: -0.05em;
  }
`

const Complaint = ({ text, show }) => {
  if (!show) { return null }

  return (
    <Wrapper>
      <svg viewBox="0 0 512 512" fill="#940420" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" fill="#940420"/>
      </svg>
      <p>{text}</p>
    </Wrapper>
  );
}

Complaint.propTypes = {
  text: PropTypes.string,
  show: PropTypes.bool,
};

export default Complaint
